import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import effectImage from "../../../assets/image/landing-effect1.webp";
import styles from "./ErrorPage.module.css";

export default function ErrorPage() {
  const navigate = useNavigate();
  const mode = useSelector((state) => state.theme.mode);
  const isDarkMode = mode !== "light";

  return (
    <div className={`position-relative d-flex flex-column align-items-center justify-content-center ${styles.container}`}>
      
      {/* Background Effects */}
      <div className={`position-absolute ${styles.bgOverlay} ${isDarkMode ? styles.bgOverlayDark : styles.bgOverlayLight}`}>
        <img src={effectImage} alt="background effect" className={styles.bgImage} />
      </div>
      <div className={styles.blobShape}></div>
      
      {/* Main Card */}
      <div className={`${styles.glassCard} ${isDarkMode ? styles.glassCardDark : styles.glassCardLight}`}>
        
        {/* Animated SVG Icon */}
        <div className={styles.iconWrapper}>
          <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="error-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#8462ff" />
                <stop offset="100%" stopColor="#ff4b4b" />
              </linearGradient>
              <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="3" result="blur" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" />
              </filter>
            </defs>
            <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="url(#error-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" filter="url(#glow)"/>
            <path d="M14 2V8H20" stroke="url(#error-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 15L15 9" stroke="url(#error-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 9L15 15" stroke="url(#error-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 className={`txt-gradient ${styles.title}`}>
          Something went wrong
        </h1>
        
        <p className={`txt-dimBlack ${styles.description}`}>
          Oops! Something unexpected happened. Don't worry, you can head back to the homepage and try again.
        </p>

        <button 
          className={`gradientButton ${styles.btnGlow} py-3 px-5 rounded fw-bold d-flex align-items-center gap-2`}
          onClick={() => navigate("/")}
        >
          <span>Go Back Home</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
